import InstanceStatus from './InstanceStatus'

export default InstanceStatus
